var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-confirm',{attrs:{"loading":_vm.loading,"confirm-title":'checkout.delete_card',"description":"checkout.are_you_sure_you_want_to_delete_this_card"},on:{"confirm":function($event){return _vm.$emit('confirmDelete')},"cancel":function($event){return _vm.$emit('closeModal')}}},[_c('icon-delete-card',{attrs:{"size":100}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }